import React from "react";
import CreateSales from "./CreateSales";
import CreateSalesMobile from "./CreateSalesMobile";

const PageSales = () => {
  return (
    <>
      <CreateSales />
    </>
  );
};
export default PageSales;
